import start_photo from '../../../img/start_photo.png';
import './Image.css';

function Image() {

  return (
    <div className='image-container'>
      <div className='img1'/>
    </div>
  );
}

export default Image;
